export enum GaEvents {
	START_REGISTRATION = "start_registration",

	// App
	OPEN_PAGE_MENU = "open_page_menu",
	OPEN_SITE = "open_site",
	SELECT_STORE = "select_store",
	SELECT_PLACE = "select_place",
	SEND_WHATS_APP = "send_whats_app",
	SEND_EMAIL = "send_email",
	SEE_WHATS_NEWS = "see_whats_news",

	PRINT_ORDER = "print_order",

	// Tips
	SEE_TIPS = "see_tips",
	SELECT_ITEM_TIPS = "select_item_tips",
	SELECT_TIP_AS_USEFUL = "select_tip_as_useful",
	SELECT_TIP_AS_USELESS = "select_tip_as_useless",

	// Help
	SELECT_QUESTION = "select_question"
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/ga-events.enum.ts